__webpack_require__.p = "https://assets-01.periodica.press/b05f2fc-21438390589/";